import apiClient from './api';
import type { ImportColumns, ImportPreview, ImportResult } from '../types/import';

// apiClient defaults to application/json, which makes axios serialize FormData as JSON
const MULTIPART_HEADERS = { 'Content-Type': 'multipart/form-data' };

export const excelImportClient = {
  // Read headers and sample rows of an .xlsx file for column mapping
  preview: async (basePath: string, file: File): Promise<ImportPreview> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`${basePath}/preview`, formData, {
      headers: MULTIPART_HEADERS,
    });
    return response.data;
  },

  // Import using the chosen columns; each field key is sent as `<key>Column`
  run: async (
    basePath: string,
    companyId: number,
    file: File,
    columns: ImportColumns,
  ): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', file);

    const params: Record<string, number | undefined> = { companyId };
    Object.entries(columns).forEach(([key, index]) => {
      params[`${key}Column`] = index;
    });

    const response = await apiClient.post(basePath, formData, {
      params,
      headers: MULTIPART_HEADERS,
    });
    return response.data;
  },
};
